
export const AuthMobils = ({auth, handleChange, error }) => 
{

return (<div className="row">
        <div className="col col-12 ">
        <h4>
            Ús del mòbil en el centre educatiu
        </h4>
        <p>
            D'acord amb el Pla de Convivència del Centre us volem informar sobre la
            NORMATIVA QUE REGULA L'ÚS DE TELÈFONS MÒBILS I APARELLS
            ELECTRÒNICS A L'INSTITUT. (basada en la Llei 12/2009, del 10 de juliol, d'Educació)  <br/>

            <ol>

            <li>L'ús del mòbil i aparells de reproducció de música està prohibit en horari de classe, dins l'aula teòrica i pràctica. 
            L'alumnat de PFI-PTT no els podrà utilitzar tampoc en tot el centre. Per tal de respectar i garantir el dret d'imatge està totalment prohibit fer fotos i/o vídeos dins
                el recinte escolar. Aquests aparells, només es podran utilitzar amb usos pedagògics quan el professor/a ho indiqui.  </li>

            <li>A l'aula, el telèfon mòbil haurà d'estar en silenci i guardat.</li>
            <li>Està totalment prohibit carregar els mòbils al centre.</li>
            <li>Si un/a professor/a detecta un alumne/a fent un ús incorrecte del mòbil durant la classe, pot demanar a l'alumne/a que apagui el dispositiu i el deixi a sobre de la taula del professor fins al final de la classe.</li>
            <li>En el cas que un/a alumne/a reincideixi es considerarà com una falta lleu i s'aplicarà el Reglament de Règim Intern del centre. 
            L'alumnat de PTT-PFI que usi el mòbil en hores de classe de manera reincident, un cop ha estat ja avisat marxarà cap a casa amb un comunicat d'incidència.</li>
            <li>EL CENTRE NO ES FA RESPONSABLE del desperfecte, de la pèrdua o sostracció dels aparells que, sota la responsabilitat de cada alumne/a, es portin a l'institut.</li>
            </ol>


            <input type="checkbox" id="authMobils" name="authMobils" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
            <label htmlFor="authMobils"> He llegit i accepto la normativa del centre que regula l'ús del mòbil i altres aparells electrònics</label>
            <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
        </p>


        </div>
    </div>)
}